import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cover-controller"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageMaskContainer = _resolveComponent("ImageMaskContainer")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ButtonSubmit = _resolveComponent("ButtonSubmit")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: _ctx.field.label,
    prop: _ctx.field.prop,
    rules: _ctx.field.rule,
    class: "FormImage",
    ref: "formItemElement"
  }, {
    default: _withCtx(() => [
      (_ctx.innerValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ImageMaskContainer, {
              modelValue: _ctx.innerValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
              disabled: _ctx.field.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.field.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ButtonSubmit, { click: _ctx.handleChangeModal }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_plus)
                  ]),
                  _: 1
                }),
                _createTextVNode(" 添加图片")
              ]),
              _: 1
            }, 8, ["click"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label", "prop", "rules"]))
}